<template>
    <div style="width: 100%; position: relative" class="pa-2">
        <TitleComponent
            v-if="box && box.reportProperties.title"
            :box="box"
            :text="box.reportProperties.title"
        />
        <div style="width: 100%; overflow-x: auto" class="scrollbar-hidden">
            <template v-if="uiType === 'table'">
                <TableComponent :tableTheme="tableTheme" :tableData="tableData" />
                <!-- <table style="width: 100%; table-layout: auto; border-spacing: 0;">
                    <thead>
                        <tr :style="thStyle">
                            <th v-for="(header, index) of box.tableData.header" :key="index" class="text-startt" :style="thStyle">{{ header }}</th>
                        </tr>
                    </thead>
                    <tbody style="text-align: right;" :style="box.selectedTableTheme.values.rows">
                        <tr v-for="(row, rIndex) of box.tableData.rows" :key="rIndex" class="text-startt">
                            <td v-for="(item, index) of row" :key="index" class="text-startt" :style="tdStyle(rIndex)">{{ item }}</td>
                        </tr>
                    </tbody>
                </table> -->
            </template>
            <template v-else-if="uiType === 'chart'">
                <template v-if="box.chartData">
                    <ChartComponent
                        :data="box.chartData"
                        :options="box.chartOptions"
                        :chartType="themeChartType"
                    />
                </template>
            </template>
            <template v-else-if="uiType === 'card'">
                <component :is="cardTag" v-bind="cardProps" />
            </template>
        </div>
    </div>
</template>
<script lang="ts">
import { Box, IndicatorComponentBoxModel, Layout, RatioComponentBoxModel } from "../models";
import {
    Line as LineChart,
    Pie as PieChart,
    Doughnut as DoughnutChart,
    Bar as BarChart,
} from "vue-chartjs";

import CardAmount from "@/views/CardAmount.vue";
import CardRatio from "@/views/CardRatio.vue";
import ChartComponent from "../ChartComponent.vue";
import TableComponent from "../TableComponent.vue";
import BoxPopupMenu from "../BoxPopupMenu.vue";
import TitleComponent from "../TitleComponent.vue";
import { Prop } from "vue-facing-decorator";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component({
    components: {
        BarChart,
        PieChart,
        DoughnutChart,
        LineChart,
        CardAmount,
        CardRatio,
        ChartComponent,
        TableComponent,
        BoxPopupMenu,
        TitleComponent,
    },
})
export class Indicator extends Vue {
    @Prop() box: IndicatorComponentBoxModel | RatioComponentBoxModel;
    @Prop() preview: boolean;

    // tableData1 = {
    //     header: ["", "N-1", "N", "Ecart"],
    //     rows: [
    //         ["Total", newCommonFormatCurrency(165978.2), newCommonFormatCurrency(275199.2530043432), newCommonFormatCurrency(275199.2530043432 - 165978.2)],
    //     ]
    // }

    // tableData2 = {
    //     header: ["", "", "01-2024", "02-2024", "03-2024", "04-2024", "05-2024", "06-2024", "07-2024", "08-2024", "09-2024",
    //         "10-2024", "11-2024", "12-2024"],
    //     rows: [
    //         ["N", "", ...([23456.2, 22890.7, 22678.1, 23145.8, 22793.6, 23001.5, 22988.3, 23412.9, 23115.7, 22876.4, 22956.2, 23083.8].map(x => newCommonFormatCurrency(x)))],
    //         ["N-1", "", ...([14321.5, 13765.3, 12897.7, 14623.8, 13412.9, 14873.4, 13521.6, 14215.2, 13874.0, 14026.7, 13942.6, 13503.5].map(x => newCommonFormatCurrency(x)))]
    //     ]
    // }

    // get tableData() {
    //     return this.box?.mergedProperties?.dense ? this.tableData1 : this.tableData2
    // }

    // chartData = {
    //     "labels": [
    //         "N-1",
    //         "N"
    //     ],
    //     "datasets": [
    //         {
    //             "label": "netAmounts",
    //             "data": [
    //                 165978.2,
    //                 275199.2530043432
    //             ],
    //             "backgroundColor": "rgba(56,144,175,1)",
    //             "borderColor": "rgba(255,255,255,0)"
    //         }
    //     ]
    // }

    // options = {
    //     responsive: true,
    //     plugins: {
    //         legend: {
    //             display: false,
    //             position: "bottom"
    //         }
    //     },
    //     scales: {
    //         y: {
    //             stacked: true,
    //             // min:0,
    //             beginAtZero: true
    //             // stepSize: 1

    //         },
    //         x: {
    //             stacked: true,
    //             // min:0,
    //             beginAtZero: true
    //         }

    //     },
    //     maintainAspectRatio: true
    // }

    get company() {
        return this.$store.state.selected_company;
    }

    get accountingPeriodId() {
        console.log("this.$store.state", this.$store.state);
        console.log(
            "this.$store.state.accountingPeriod?.selectedAccountingPeriod?.id",
            this.$store.state.accountingPeriod?.selectedAccountingPeriod?.id
        );
        return this.$store.state.accountingPeriod?.selectedAccountingPeriod?.id;
    }

    get selectedAccountingPeriod() {
        return this.$store.state.accountingPeriod?.selectedAccountingPeriod;
    }

    get selectedAccountingClosing() {
        return this.$store.state.accountingPeriod?.selectedAccountingClosing;
    }

    get accountingPeriods() {
        return this.$store.state.accountingPeriod?.accountingPeriods;
    }

    get uiType() {
        return this.box?.mergedProperties?.ui;
    }

    get cardTag() {
        return this.box?.bobbeeCardTag;
    }

    get cardProps() {
        return this.box?.bobbeeCardProps ?? {};
    }

    get themeChartType() {
        return this.box.selectedChartTheme.values.type ?? "bar";
    }

    formatTableCellStyle(style) {
        return {
            background: style.background,
            color: style.color,
            textAlign: style.textAlign,
            borderStyle: style.border ? "solid" : null,
            borderWidth: style.border ? "1px" : null,
            borderColor: style.borderColor,
            fontWeight: style.bold ? "bold" : null,
            boxSizing: "border-box",
            borderCollapse: "collapse",
            borderSpacing: 0,
            padding: "2px",
        };
    }

    get thStyle() {
        const style = this.box.selectedTableTheme?.values.header ?? {};
        return this.formatTableCellStyle(style);
    }

    tdStyle(rowIndex) {
        const style = { ...(this.box.selectedTableTheme?.values.rows ?? {}) };
        if (
            rowIndex != null &&
            rowIndex % 2 == 0 &&
            style.mode === "alternating" &&
            style.secondaryColor
        ) {
            style.background = style.secondaryColor;
        }
        return this.formatTableCellStyle(style);
    }

    get tableData() {
        if (!this.box?.tableData) {
            return [];
        }
        const headers = this.box.tableData.headers;
        const rows = [];
        let i = 0;
        for (const row of this.box.tableData.rows) {
            const rowData = {
                type: "normal",
                values: row.map((a) => ({ text: a, type: i === 0 ? "string" : "amount" })),
            };
            rows.push(rowData);
        }

        console.log("indicator tableData", { headers, rows });

        return { headers, rows };
    }

    get tableTheme() {
        return this.box.selectedTableTheme.values;
    }
}

export default toNative(Indicator);
</script>
<style lang="css" scoped>
.text-field {
    height: 100%;
    width: 100%;
}

:is(.text-field, td, th, tr):is(.center, .middle, .text-center, .text-middle) {
    text-align: center;
}

:is(.text-field, td, th, tr):is(.start, .text-start) {
    text-align: start;
}

:is(.text-field, td, th, tr):is(.end, .text-end) {
    text-align: end;
}

.title {
    border: 1px solid;
    overflow-x: hidden;
    text-wrap: wrap;
    margin-bottom: 8px;
}

.scrollbar-hidden::-webkit-scrollbar {
    overflow: auto;
    display: none;
    width: 12px;
}

.scrollbar-hidden {
    overflow: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
}
</style>
